import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import { configuration } from "../../helper/appconfig";
import toastAlert from "../../helper/ToastAlert/ToastAlert";
import { Autocomplete, Box, TextField, Grid } from "@mui/material";
import { Link } from "react-router-dom";
import { handleAuthTokenError } from "../../redux/actions/authActions";
import { TableRow, TableCell } from "@mui/material";
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import PolicyOutlinedIcon from '@mui/icons-material/PolicyOutlined';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import StyledTable from '../../components/StyledTable';
import { EmptyState } from '../../components/DesignSystem';

const GroupTableValue = () => [
    {
        name: "Index",
        options: { filter: false, sort: false, customBodyRender: (value) => value ? <div className="table_data table_data_index"><p>{value}</p></div> : null },
    },
    {
        name: "Group Name",
        options: { filter: true, customBodyRender: (value) => value ? <div className="table_data"><p style={{ fontWeight: 500 }}>{value}</p></div> : null },
    },
    {
        name: "Group Id",
        options: { filter: true, customBodyRender: (value) => <div className="table_data"><p style={{ fontFamily: "'Courier New', monospace", fontSize: '12px' }}>{value}</p></div> },
    },
    {
        name: "Description",
        options: { filter: true, customBodyRender: (value) => <div className="table_data"><p style={{ color: '#666' }}>{value || '-'}</p></div> },
    },
];

const AttachedPolicyValue = () => [
    {
        name: "Index",
        options: { filter: false, sort: false, customBodyRender: (value) => value ? <div className="table_data table_data_index"><p>{value}</p></div> : null },
    },
    {
        name: "Policy Name",
        options: { filter: true, customBodyRender: (value) => value ? <div className="table_data"><p style={{ fontWeight: 500 }}>{value}</p></div> : null },
    },
    {
        name: "Policy Id",
        options: { filter: true, customBodyRender: (value) => <div className="table_data"><p style={{ fontFamily: "'Courier New', monospace", fontSize: '12px' }}>{value}</p></div> },
    },
];

class UserGroups extends Component {
    constructor() {
        super();
        this.state = {
            groupData: [],
            attachedPolicies: [],
            loading: false,
            selectedId: null,
            userData: [],
        };
    }

    itemArray = () => {
        return [
            { name: "Lab Access", active: false, link: "" },
            { name: "User Groups", active: true, link: "" },
        ];
    };

    renderGroupData = () => {
        const { groupData } = this.state;
        if (groupData?.length) {
            return groupData.map((group, idx) => [
                idx + 1,
                group?.GroupName,
                group?.GroupId,
                group?.Description,
            ]);
        }
        return [];
    };

    renderAttachedPolicyData = () => {
        if (this?.state?.attachedPolicies?.length) {
            return this.state.attachedPolicies.map((policy, idx) => [
                idx + 1,
                policy?.policyName,
                policy?.policyId,
            ]);
        }
        return [];
    };

    setID = (evt, val) => {
        if (val == null) {
            this.setState({ selectedId: val, loading: false, groupData: [], attachedPolicies: [] });
            return;
        }
        this.setState({ selectedId: val, loading: true }, () => {
            this.getMyGroups(val);
            this.getAttachedPolicies(val);
        });
    };

    getFilteredUsers = (evt) => {
        const url = configuration.userList;
        const tokenType = this.props?.authData?.tokenType;
        const idToken = this.props?.authData?.idToken;
        const headers = { "Authorization": `${tokenType} ${idToken}` };
        let body = { "limit": "60", "filter": evt.target.value };
        axios.post(url, body, { headers })
            .then((response) => {
                this.setState({ userData: response.data?.Users });
            })
            .catch((error) => {
                let errorMessage = error?.response?.data?.message;
                if (errorMessage === "Unauthorized") this?.props?.handleAuthTokenError(this.props);
                if (!error.response) {
                    toastAlert("Please check your internet connection.", "error");
                } else {
                    toastAlert(errorMessage || "Something went wrong. Please try again later.", "error");
                }
            });
    };

    getMyGroups = (data) => {
        const url = configuration.getMyGroups;
        const tokenType = this.props?.authData?.tokenType;
        const idToken = this.props?.authData?.idToken;
        const headers = { Authorization: `${tokenType} ${idToken}` };
        const params = { emailId: data?.Email };

        axios.get(url, { headers, params })
            .then((response) => {
                this.setState({ groupData: response?.data, loading: false });
            })
            .catch((error) => {
                let errorMessage = error?.response?.data?.message;
                if (errorMessage === "Unauthorized") this?.props?.handleAuthTokenError(this.props);
                this.setState({ loading: false });
                if (!error.response) {
                    toastAlert("Please check your internet connection.", "error");
                } else {
                    toastAlert(errorMessage || "Something went wrong. Please try again later.", "error");
                }
            });
    };

    getAttachedPolicies = (data) => {
        const url = configuration.getSingleAttachedPolicy;
        const tokenType = this.props?.authData?.tokenType;
        const idToken = this.props?.authData?.idToken;
        const headers = { Authorization: `${tokenType} ${idToken}` };
        const params = { Id: data?.userId };

        axios.get(url, { headers, params })
            .then((response) => {
                this.setState({ attachedPolicies: response?.data.attachedPolicies, loading: false });
            })
            .catch((error) => {
                let errorMessage = error?.response?.data?.message;
                if (errorMessage === "Unauthorized") this?.props?.handleAuthTokenError(this.props);
                this.setState({ loading: false });
                if (!error.response) {
                    toastAlert("Please check your internet connection.", "error");
                } else {
                    toastAlert(errorMessage || "Something went wrong. Please try again later.", "error");
                }
            });
    };

    render() {
        const { loading, groupData, attachedPolicies, selectedId, userData } = this?.state;

        const groupsOptions = {
            customRowRender: (data, rowIndex) => {
                const groupId = groupData[rowIndex]?.GroupId;
                const groupName = groupData[rowIndex]?.GroupName;
                return (
                    <TableRow component={Link} to={{ pathname: `/groupPolicies/${groupId}`, state: { groupName } }} key={rowIndex} hover style={{ textDecoration: 'none' }}>
                        {data.map((cell, index) => <TableCell key={index}>{cell}</TableCell>)}
                    </TableRow>
                );
            },
        };

        const policyOptions = {
            customRowRender: (data, rowIndex) => {
                const policyId = attachedPolicies[rowIndex]?.policyId;
                const policyName = attachedPolicies[rowIndex]?.policyName;
                return (
                    <TableRow component={Link} to={{ pathname: `/viewPolicy/${policyId}`, state: { policyName } }} key={rowIndex} hover style={{ textDecoration: 'none' }}>
                        {data.map((cell, index) => <TableCell key={index}>{cell}</TableCell>)}
                    </TableRow>
                );
            },
        };

        const showEmpty = (!groupData || groupData.length === 0) && (!attachedPolicies || attachedPolicies.length === 0) && !loading;

        return (
            <div>
                <Breadcrumb items={this?.itemArray()} />

                {/* Search Bar */}
                <div style={{ marginTop: '16px', marginBottom: '16px', maxWidth: '480px' }}>
                    <Autocomplete
                        name="selectedId"
                        value={selectedId}
                        id="user-search"
                        options={userData}
                        size="small"
                        onChange={(event, value) => this.setID(event, value)}
                        getOptionLabel={(option) => option?.Name ? `${option.Name} (${option.Email})` : option?.Email}
                        filterSelectedOptions
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Search User"
                                placeholder="Search by name or email"
                                onChange={(e) => this.getFilteredUsers(e)}
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        borderRadius: '10px',
                                        fontSize: '13px',
                                        '&.Mui-focused fieldset': { borderColor: '#6AB43E' },
                                    },
                                    '& .MuiInputLabel-root.Mui-focused': { color: '#6AB43E' },
                                }}
                            />
                        )}
                        renderOption={(props, option) => (
                            <Box component="li" {...props}>
                                {option?.Name ? `${option.Name} — ${option.Email}` : option.Email}
                            </Box>
                        )}
                    />
                </div>

                {/* Groups Table */}
                {groupData && groupData.length > 0 && (
                    <StyledTable
                        title="User Groups"
                        icon={<GroupsOutlinedIcon />}
                        subtitle={`${groupData.length} groups`}
                        loading={loading}
                        data={this.renderGroupData()}
                        columns={GroupTableValue()}
                        options={groupsOptions}
                        emptyMessage="No groups found for this user"
                    />
                )}

                {/* Attached Policies Table */}
                {attachedPolicies && attachedPolicies.length > 0 && (
                    <div style={{ marginTop: '24px' }}>
                        <StyledTable
                            title="User Attached Policies"
                            icon={<PolicyOutlinedIcon />}
                            subtitle={`${attachedPolicies.length} policies`}
                            loading={loading}
                            data={this.renderAttachedPolicyData()}
                            columns={AttachedPolicyValue()}
                            options={policyOptions}
                            emptyMessage="No policies attached"
                        />
                    </div>
                )}

                {/* Empty State */}
                {showEmpty && (
                    <EmptyState
                        title="Search a user to view data"
                        description="Select a user from the search bar above to see their groups and attached policies."
                        icon={<SearchOutlinedIcon />}
                    />
                )}
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    authData: state.authReducer,
});

export default connect(mapStateToProps, { handleAuthTokenError })(UserGroups);
